import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";

import { type AccountManagerResponse, accountManagerResponseSchema } from "./types";

export interface GetAccountManagerParams {
  facilityId?: string;
}

export function useGetAccountManager(
  params: GetAccountManagerParams,
  options: UseGetQueryOptions<AccountManagerResponse> = {}
): UseQueryResult<AccountManagerResponse> {
  const { facilityId } = params;
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${facilityId}?include=accountManager`,
    responseSchema: accountManagerResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_ACCOUNT_MANAGER_FAILURE,
    },
    staleTime: 60 * 1000,
    enabled: isDefined(facilityId),
    useErrorBoundary: false,
    retry: (failureCount, error) =>
      failureCount < 3 && isDefined(error.response) && error.response.status >= 500,
    ...options,
  });
}
